import { io } from 'socket.io-client';

const token = localStorage.getItem("token");

const socket = io(process.env.REACT_APP_API_URL, {
  cors: {
    origin: "http://localhost:3000"
  },
  auth: {
    token: `JWT ${JSON.parse(token)}`,
  },
  autoConnect: false,
  transports: ['websocket'],
});



export default socket;
